/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_BulkDataSubscriptionAttributes_ } from '../models/ControllerResponse_BulkDataSubscriptionAttributes_';
import type { ControllerResponse_BulkDataSubscriptionAttributes_Array_ } from '../models/ControllerResponse_BulkDataSubscriptionAttributes_Array_';
import type { ControllerResponse_BulkDataSubscriptionAttributes_or_null_ } from '../models/ControllerResponse_BulkDataSubscriptionAttributes_or_null_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BulkDataService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ControllerResponse_BulkDataSubscriptionAttributes_Array_ Ok
     * @throws ApiError
     */
    public list(): CancelablePromise<ControllerResponse_BulkDataSubscriptionAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bulk_data/list',
        });
    }
    /**
     * @param id
     * @returns ControllerResponse_BulkDataSubscriptionAttributes_or_null_ Ok
     * @throws ApiError
     */
    public get(
        id: number,
    ): CancelablePromise<ControllerResponse_BulkDataSubscriptionAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bulk_data',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns ControllerResponse_BulkDataSubscriptionAttributes_ Ok
     * @throws ApiError
     */
    public update(
        id: number,
        requestBody: {
            schedule: Array<string>;
            emails_enabled: boolean;
            emails: Array<string>;
        },
    ): CancelablePromise<ControllerResponse_BulkDataSubscriptionAttributes_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/bulk_data',
            query: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @deprecated
     * @param msa
     * @param minUnits
     * @param maxUnits
     * @param minYearBuilt
     * @param maxYearBuilt
     * @param isSingleFamily
     * @param isCondo
     * @param isApartment
     * @param isSenior
     * @param isStudent
     * @param isAffordable
     * @param fromDate
     * @param toDate
     * @returns any Ok
     * @throws ApiError
     */
    public export(
        msa: string,
        minUnits?: number,
        maxUnits?: number,
        minYearBuilt?: number,
        maxYearBuilt?: number,
        isSingleFamily?: boolean,
        isCondo?: boolean,
        isApartment?: boolean,
        isSenior?: boolean,
        isStudent?: boolean,
        isAffordable?: boolean,
        fromDate?: string,
        toDate?: string,
    ): CancelablePromise<{
        expires: string;
        url: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bulk_data/export',
            query: {
                'msa': msa,
                'min_units': minUnits,
                'max_units': maxUnits,
                'min_year_built': minYearBuilt,
                'max_year_built': maxYearBuilt,
                'is_single_family': isSingleFamily,
                'is_condo': isCondo,
                'is_apartment': isApartment,
                'is_senior': isSenior,
                'is_student': isStudent,
                'is_affordable': isAffordable,
                'from_date': fromDate,
                'to_date': toDate,
            },
        });
    }
}
